/**
 * @module Annual Report - Tabset
 * @description JS for Annual Report Template - Tabset
 */
import { tabChange } from './sliders.js';
import { setData } from './bind-data.js';

const els = {
  map: null,
  tabset: null,
};


const state = {
  initTab: null
};


/**
 * @function tabActivate
 * @description set the active tab
 */
const tabActivate = ( tab ) => {
    const id = Number( tab.getAttribute( 'data-tab' ) );
    const type = tab.getAttribute( 'data-value' );

    // Tab
    tab.classList.add( '--is-active' );
    tab.setAttribute( 'data-tab-active', true );

    // Tab Content
    const content = els.tabset.querySelector( `[data-tab-content="${ id }"]` );
    content.classList.add( '--is-active' );
    content.setAttribute( 'data-tab-active', true );

    if( ! type ) {
      return;
    }

    const select = els.tabset.querySelector( `.ins-annual-report__tabs--select-${ type }` );

    if( select ) {
      const selectParent = select.parentNode;
      selectParent.classList.add( '--is-active' );
      selectParent.setAttribute( 'data-tab-active', true );
    }

    els.map.setAttribute( 'data-view',  type );
};


/**
 * @function tabDeactivate
 * @description set other tabs to deactivate
 */
const tabDeactivate = ( tab ) => {
    const id = Number( tab.getAttribute( 'data-tab' ) );
    const type = tab.getAttribute( 'data-value' );

    // Tab
    tab.classList.remove( '--is-active');
    tab.setAttribute( 'data-tab-active', false );

    // Tab Content
    const content = els.tabset.querySelector( `[data-tab-content="${ id }"]` )
    content.classList.remove( '--is-active' );
    content.setAttribute( 'data-tab-active', false );

    if( ! type ) {
      return;
    }

    const select = els.tabset.querySelector( `.ins-annual-report__tabs--select-${ type }` );

    if( select ) {
      const selectParent = select.parentNode;
      selectParent.classList.remove( '--is-active' );
      selectParent.setAttribute( 'data-tab-active', false );
    }
};


/**
 * @function setTabState
 * @description Bind Events for this module
 */
const setTabState = ( event ) => {
  event.preventDefault();

  const { target } = event;
  const tabIndex = Number( target.getAttribute( 'data-tab' ) );
  const siblings = els.tabset.querySelectorAll( '[data-tab]' );
  const siblingTabs = Array.prototype.slice.call( siblings ).filter( ( sibling ) => Number( sibling.getAttribute( 'data-tab' ) ) !== tabIndex );

  tabActivate( target );

  siblingTabs.forEach( ( sibling ) => {
      tabDeactivate( sibling );
  } );

  tabChange( tabIndex );
}


/**
 * @function setInitTab
 * @description Set our init tab
 */
const setInitTab = () => {
  if( state.initTab !== null ) {
      const activeTabs = els.tabset.querySelectorAll(`[data-tab="${ state.initTab }"]` );
      activeTabs.forEach( ( tab) => {
          tabActivate( tab );
      } );
  }
}

/**
 * @function bindSelectEvents
 * @description Bind Select Events for this module
 */
const bindSelectEvents = ( select ) => {
  select.addEventListener( 'change', setData );
}


/**
 * @function bindTabEvents
 * @description Bind Tab Events for this module
 */
const bindTabEvents = ( tabLink ) => {
  tabLink.addEventListener( 'click', setTabState );
}


/**
 * @function init
 * @description Kick off this modules functions
 */
const init = ( tabset, map ) => {
  els.tabset = tabset;
  els.map = map;
  const selects = els.tabset.querySelectorAll( '.ins-annual-report__tabs--select' );
  state.initTab = els.tabset.hasAttribute( 'data-tab-init' ) ? Number( els.tabset.getAttribute( 'data-tab-init' ) ) : null;
  const tabs = els.tabset.querySelectorAll( '.ins-annual-report__tab-item' );

  tabs.forEach( ( tab ) => {
    const tabLink = tab.querySelector( '[data-tab]' );

    if( tabLink ) {
      tabLink.setAttribute( 'data-tab-active', false );
      bindTabEvents( tabLink );
    }
  } );

  selects.forEach( ( select ) => {
    bindSelectEvents( select );
  } );

  setInitTab();
}

export default init
